'use client'

import React, { createContext, useContext, useEffect, useState } from 'react'

type AppStorageState = {
  pageLoads: number
}

type AppStorageContext = {
  state: AppStorageState | null
  incrementPageLoads: () => void
}

const AppStorageContext = createContext<AppStorageContext | undefined>(undefined)

export const AppStorageProvider = ({ children }: { children: React.ReactNode }) => {
  const [state, setState] = useState<AppStorageState | null>(null)

  const loadState = () => {
    const storedState = window.localStorage.getItem('appStorage')
    if (storedState) {
      setState(JSON.parse(storedState))
    }
  }

  useEffect(() => {
    loadState()
    window.addEventListener('storage', loadState)
    return () => window.removeEventListener('storage', loadState)
  }, [])

  useEffect(() => {
    window.localStorage.setItem('appStorage', JSON.stringify(state))
  }, [state])

  const incrementPageLoads = () => {
    if (!state) return
    setState({ ...state, pageLoads: state.pageLoads + 1 })
  }
  const value = {
    state,
    incrementPageLoads,
  }
  return <AppStorageContext.Provider value={value}>{children}</AppStorageContext.Provider>
}

export const useAppStorage = () => {
  const context = useContext(AppStorageContext)
  if (!context) {
    throw new Error('useAppStorage must be used within an AppStorageProvider')
  }
  return context
}
